import $ from "jquery";

var eshopCatalog = {

	init: function() {
		// select pro razeni vypisu katalogu
		$("#sortby").on('change', function() {
			let url = $(this).attr('url');
			const val = $(this).find("option:checked").val();
			if (url.indexOf('orderby') != -1) {
				url = url.replace(/orderby=\w+/, 'orderby=' + val);
			} else if (url.indexOf('?') != -1) {
				url = url + '&orderby=' + val;
			} else {
				url = url + '?orderby=' + val;
			}

			window.location.href = url;
		});

		// select pro nastaveni poctu vypsanych polozek
		// Show count
		$("#showcount").on('change', function() {
			let url = $(this).attr('url');
			const val = $(this).find("option:selected").val();
			if (url.indexOf('perpage') != -1) {
				url = url.replace(/perpage=[^&]+/, 'perpage=' + val);
			} else if (url.indexOf('?') != -1) {
				url = url + '&perpage=' + val;
			} else {
				url = url + '?perpage=' + val;
			}

			window.location.href = url;
		});

		$(".radios-box_variant input").change(function () {
			var val = $(this).val();
			var id = $(this).attr("id");
			var title = $(".radios-box_variant title[for='" + id + "']");

			// console.log('change to ', val, id, title.text());

			$("form.basket_insert input[name='variant_id']").val(val);

			$("h2.product-detail__title").html(title.text());
			// $(".availability-box .item-available").html(title.attr("availability"));
			// if (title.attr("availabilitytype") == 1) {
			// 	$(".availability-box .item-available").addClass("onstock");
			// } else {
			// 	$(".availability-box .item-available").removeClass("onstock");
			// }
			// if (title.attr("availabilitytype") == 6) { // vyprodano
			// 	$(".basket_insert").hide();
			// } else {
			// 	$(".basket_insert").show();
			// }

			if (typeof combinations[val] != "undefined") {
				window.location.replace(combinations[val]);
			}
		});



	}
};

var eshopCatalogList = {

    increase: 4,
    displayed: 21,
    showLimit: 21,
    loaded: 0,
    url: window.location.href,
    postData: {
        page: "eshopCatalog",
        action: "show",
        ajax: 1
    },

    init: function(){
        $(".pagination__wrapper").hide();

        $('#catalog-list-load-more').click(function(event){
            event.preventDefault();

            $('#catalog-list-load-more').parents(".pagination--bottom").append("<div class='loader'></div>");

            var loadPromise = eshopCatalogList.loadItems();
            loadPromise.done(function(){
                $('#catalog-list-load-more').parents(".pagination--bottom").find(".loader").remove();
                eshopCatalogList.showItems();
                eshopCatalogList.init();
            });
        });

        eshopCatalogList.loaded = eshopCatalogList.displayed = $("#content-body .productlist > .list > .item").length; // eshopCatalogList.displayed;
        eshopCatalogList.showLimit = parseInt($("#showcount").val());
    },

    loadItems: function(catCooluri, offset, limit){

        var data = eshopCatalogList.postData;

        if(typeof offset === 'undefined'){offset = eshopCatalogList.loaded;}
        if(typeof limit === 'undefined'){limit = eshopCatalogList.showLimit;}

        data.offset = offset;
        data.limit = limit;

        if(typeof catCooluri !== 'undefined'){
            data.cat = catCooluri;
        }

        var promise = $.ajax({
            url: eshopCatalogList.url,
            type: 'POST',
            dataType: 'html',
            data: data,
        });
        promise.done(function (response) {
            var $response = $("<div>");
            $response.html(response);

            $("#content-body .productlist .list").append($response.find(".list").html());
            $("#content-body .pagination").replaceWith($response.find(".pagination"));
            $("#content-body .pagination .pagination__info--start").text(0);

            if($response.find('script.ga-event-script'))
            {
                $('head').append($response.find('script.ga-event-script'));
            }

            eshopCatalogList.loaded = eshopCatalogList.loaded + $response.find(".list .item").length;
        });
        return promise;
    },

    showItems: function(){
        var setDisplayed = eshopCatalogList.displayed + eshopCatalogList.showLimit;

        $(".productlist .list .item:nth-child(n+"+(eshopCatalogList.displayed + 1)+"):nth-child(-n+"+(setDisplayed)+")").css({"opacity": 0}).addClass("opened").slideDown(1000);
        eshopCatalogList.slideDown(setDisplayed, eshopCatalogList.displayed, eshopCatalogList.increase);

        eshopCatalogList.displayed = setDisplayed;
        $('#catalog-list-load-more').parents(".pagination").removeClass("loader");
    },

    slideDown: function(finalCount, count, increase){
        var setCount = count + increase;

        $("#content-body .productlist .list .item:nth-child(n+"+count+"):nth-child(-n+"+setCount+")")
            .animate({
                opacity: 1
            }, {
                duration: 500,
                queue: false
            })
            .promise().done(function() {
            if(setCount < finalCount){
                eshopCatalogList.slideDown(finalCount, setCount, increase);
            }
        });
    }
};

$(function (){
	eshopCatalog.init();
    eshopCatalogList.init();
});